export default __webpack_public_path__ + "static/media/js.b8eabfa0.png";